var mixins = {
    data () {
        return {
            loading: true,
            errorMsgs: []
        }
    },
    methods: {
        getFormAction: function (form) {
            return form.getAttribute("action");
        },

        removeDuplicates: function (array) {
            return array.filter((c, index) => {
                return array.indexOf(c) === index;
            });
        },

        getData: function (objName) {
            return typeof window[objName] !== "undefined"
                ? window[objName]
                : null;
        },

        getDataText: function (objName, val) {
            if (typeof window[objName] === "undefined") {
                return "";
            }
            var entry = window[objName].find((i) => i.value === val);

            if (typeof entry === "undefined") {
                return "";
            }

            return entry.text;
        },

        makeid: function (length = 10) {
            var result = "";
            var characters =
                "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            var charactersLength = characters.length;
            for (var i = 0; i < length; i++) {
                result += characters.charAt(
                    Math.floor(Math.random() * charactersLength)
                );
            }
            return result;
        },

        validateFields: function (names) {
            if (names === "") {
                return true;
            }

            var validArray = [];

            names.split(",").forEach((item, index) => {
                validArray.push(jQuery(`*[name ="${item.trim()}"]`).valid());
            });

            if (validArray.includes(false)) {
                return false;
            }

            return true;
        },

        getAllFields: function (elemId) {
            var fieldsArray = [];
            var inputs = jQuery(`#${elemId}`).find(":input");

            inputs.each(function () {
                var name = jQuery(this).attr("name");
                if (name !== "" && typeof name !== "undefined") {
                    fieldsArray.push(name);
                }
            });

            return fieldsArray.join();
        },

        iniReCaptcha: function (elem) {
            var self = this;

            Vue.nextTick(function () {
                self.reCaptcha = jQuery(".e-g-recaptcha", elem);

                grecaptcha.render(self.reCaptcha.attr("id"), {
                    sitekey: self.reCaptcha.data("sitekey"),
                });
            });
        },

        scrollToError: function (offsetY = 0) {
            Vue.nextTick(function () {
                jQuery([document.documentElement, document.body]).animate(
                    {
                        scrollTop: jQuery(".alert").offset().top - offsetY,
                    },
                    100,
                    "linear"
                );
            });
        },

        scrollToValidation: function (offsetY = 50) {
            Vue.nextTick(function () {
                var barH = jQuery(".s-booking-bar").length
                    ? jQuery(".s-booking-bar").outerHeight()
                    : 0;

                var elem = jQuery(".error--text").first();
                if (!elem.length) {
                    return false;
                }

                jQuery([document.documentElement, document.body]).animate(
                    {
                        scrollTop: elem.offset().top - offsetY - barH,
                    },
                    100,
                    "linear"
                );
            });
        },

        scrollToTop: function () {
            Vue.nextTick(function () {
                jQuery([document.documentElement, document.body]).animate(
                    {
                        scrollTop: jQuery("html").offset().top,
                    },
                    'slow',
                    "linear"
                );
            });
        },

        scrollToElem: function (elem, offsetY = 0) {
            Vue.nextTick(function () {
                jQuery([document.documentElement, document.body]).animate(
                    {
                        scrollTop: elem.offset().top - offsetY,
                    },
                    'slow',
                    "linear"
                );
            });
        },

        getIndex: function (index) {
            return index + 1;
        },

        hasValue: function (val) {
            return typeof val !== "undefined" && val !== null && val !== "";
        },

        showErrorDialog: function (message) {
            this.errorDialog = true;
            this.errorMsg = this.hasValue(this.dictionary)
                ? this.dictionary.serverErrorMsg
                : "";

            if (this.hasValue(message)) {
                this.errorMsg = message;
            }
        },

        getAjaxResponseMessages: function (messages) {
            let msg = Array.isArray(messages) ? messages[0] : messages;

            if (messages.length > 1 && Array.isArray(messages)) {
                let msgList = "<ul>";
                messages.forEach((item) => {
                    msgList += `<li>${item}</li>`;
                });
                msgList += "</ul>";
                msg = msgList;
            }

            return msg;
        },

        getRandomInt: function (max) {
            return Math.floor(Math.random() * Math.floor(max));
        },

        getUrlVars: function () {
            var vars = {};
            var parts = window.location.href.replace(
                /[?&]+([^=&]+)=([^&]*)/gi,
                function (m, key, value) {
                    vars[key] = value;
                }
            );
            return vars;
        },

        getUrlParam: function (parameter, defaultvalue) {
            var urlparameter = defaultvalue;
            if (window.location.href.indexOf(parameter) > -1) {
                urlparameter = this.getUrlVars()[parameter];
            }
            return urlparameter;
        },

        getCharPosition: function (string, char, index) {
            return string.split(char, index).join(char).length;
        },

        appendUrlParam: function (parameter, value) {
            var url = new URL(window.location.href);
            var search_params = url.searchParams;

            if (this.urlParamExists(parameter)) {
                search_params.set(parameter, value);
            } else {
                search_params.append(parameter, value);
            }

            url.search = search_params.toString();

            var new_url = decodeURIComponent(url.toString());

            history.pushState({}, null, new_url);
        },

        appendUrlParams: function (parameters, values) {
            var url = new URL(window.location.href);
            var search_params = url.searchParams;

            var i;
            for (i = 0; i < parameters.length; i++) {
                if (this.urlParamExists(parameters[i])) {
                    search_params.set(parameters[i], values[i]);
                } else {
                    search_params.append(parameters[i], values[i]);
                }
            }

            url.search = search_params.toString();

            var new_url = decodeURIComponent(url.toString());

            history.pushState({}, null, new_url);
        },

        urlParamExists: function (field) {
            var url = window.location.href;
            if (url.indexOf("?" + field + "=") != -1) return true;
            else if (url.indexOf("&" + field + "=") != -1) return true;
            return false;
        },

        coordinatesAreValid: function (long, lat) {
            if (!this.hasValue(long)) {
                return false;
            }

            if (!this.hasValue(lat)) {
                return false;
            }

            if (lat === 0) {
                return false;
            }

            if (long === 0) {
                return false;
            }

            return true;
        },

        trimChar: function (string, charToRemove) {
            while (string.charAt(0) == charToRemove) {
                string = string.substring(1);
            }

            while (string.charAt(string.length - 1) == charToRemove) {
                string = string.substring(0, string.length - 1);
            }

            return string;
        },

        getCharacteristicTooltip: function (item) {
            if (this.hasValue(item.tooltip)) {
                return `${item.text}: ${item.tooltip}`;
            }

            return item.text;
        },

        getInfoWindowContentString: function (item) {
            var url = this.hasValue(item.url) ? item.url : "javascript:void(0)";
            var className = this.hasValue(item.url) ? "" : "void";
            var target = this.hasValue(item.url) ? "_blank" : "";

            return `<div class="e-bubble">
							<div class="e-bubble__img">
								<a href="${url}" title="${item.title}" target="${target}" class="${className}">
									<img src=" ${item.img} ">
								</a>
							</div>
							<div class="e-bubble__info">
								<a href="${url}" title="${item.title}" target="${target}" class="${className}">
									<h3>${item.title}</h3>
								</a>
								<p>${item.address}</p>
							</div>
						</div>`;
        },

        ajax(handler, obj){
            try {
                axios
                    .post(handler, obj)
                    .then((response) => {
                        var { hasError, errorMessages, data, allItems } = response.data;

                        if (hasError) {                           
                            this.handleAjaxError(errorMessages);
                            return false;
                        }                      
                       
                        this.handleAjaxSuccess(data, response.data);
                    })
                    .catch((errors) => {
                        this.handleAjaxError([errors]);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            } catch (err) {
                this.loading = false;
                this.handleAjaxError(JSON.parse(err));
            }
        },
        
        handleAjaxError(messages) {
            this.errorMsgs = this.hasValue(messages) ? messages : [];
        },

        changeAllNodes: function(currentNode, callback){
            for (var k in currentNode) {
                if (typeof currentNode[k] == "object" && currentNode[k] !== null)
                    this.changeAllNodes(currentNode[k], callback);
                else {
                    if(typeof callback === "function"){
                        callback(currentNode)
                    }
                }
            }
        }, 
        findNode: function(id, currentNode, nodeName, callback) {
            var i, currentChild, result;

            if (id == currentNode.id) {
                return currentNode;
            } else {
                if(currentNode && currentNode[nodeName]){
                    for (i = 0; i < currentNode[nodeName].length; i += 1) {
                        currentChild = currentNode[nodeName][i];
                        result = this.findNode(id, currentChild, callback);
                        if (result) {
                            if(!callback){
                                return result;
                            } else {
                                if(typeof callback === "function"){
                                    callback(currentChild, result)
                                    return result;
                                }
                            }
                        }
                    }
                }
                return false;
            }
        },
        findValues(obj, key){
            return this.findValuesHelper(obj, key, []);
        },
        findValuesHelper: function(obj, key, list) {
            if (!obj) return list;
            if (obj instanceof Array) {
              for (var i in obj) {
                  list = list.concat(this.findValuesHelper(obj[i], key, []));
              }
              return list;
            }
            if (obj[key]) list.push(obj);
          
            if ((typeof obj == "object") && (obj !== null) ){
                var children = Object.keys(obj);
                if (children.length > 0){
                    for (i = 0; i < children.length; i++ ){
                      list = list.concat(this.findValuesHelper(obj[children[i]], key, []));
                    }
                }
            }
            return list;
        }

    },
};
